var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-view',[_c('div',{staticClass:"support"},[_c('div',{staticClass:"support-information"},[_c('div',[_c('p',[_vm._v(" "+_vm._s(_vm._f("translate")('support.help')))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }